import React from 'react';
import TextField from 'material-ui/TextField';
import Chip from 'material-ui/Chip';
import Toggle from 'material-ui/Toggle';
import { white, cyan500 } from 'material-ui/styles/colors';
// import {styles} from './styles';

export const renderTextField = ({input, label, meta: {touched, error}, ...rest}) => (
  <TextField
    {...rest}
    {...input}
    onChange={(event, value) => input.onChange(value)}
    hintText={label}
    floatingLabelText={label}
    errorText={touched && error}/>
);
export const renderFullTextField = ({input, label, meta: {touched, error}, ...rest}) => (
  <TextField
    {...rest}
    {...input}
    onChange={(event, value) => input.onChange(value)}
    hintText={label}
    floatingLabelText={label}
    fullWidth={true}
    multiLine={true}
    errorText={touched && error}/>
);


export const renderNumberField = ({input, label, meta: {touched, error}, ...rest, style}) => (
  <TextField
    {...rest}
    {...input}
    type={'number'}
    style={style||{}}
    onChange={(event, value) => input.onChange(value)}
    hintText={label}
    floatingLabelText={label}
    errorText={touched && error}/>
);

// export const renderChipText = ({input, label, meta: {touched, error}, ...rest}) => (
//   <div>
//     <div style={{marginBottom:8}}>{label}</div>
//     <Chip>
//       {input.value}
//     </Chip>
//   </div>

// )

export const renderToggle = ({input, label, meta: {touched, error}, ...options}) => (
    <Toggle
      defaultToggled={!!input.value}
      onToggle={input.onChange}
      label={label}
      labelPosition="right"
      {...options}/>
  )

  const checkText = (value) => {
    return value.replace('_', ' ');
  }
  export const renderChipVariantName = ({input, label, meta: {touched, error}, ...rest}) => (
    <div>
      <div style={{marginBottom:8}}>{label}</div>
      <Chip
        backgroundColor={cyan500}
        labelColor={white}
      >
        {checkText(input.value)}
      </Chip>
    </div>
  );
  


// WEBPACK FOOTER //
// ./src/products/ProductFormField.js